/* import __COLOCATED_TEMPLATE__ from './call-outcome-conversation-item.hbs'; */
/* RESPONSIBLE TEAM: team-fin-voice */
import Component from '@glimmer/component';
import type { FormattedConversationCallOutcome } from '../conversation-item';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';

export interface ConversationArgs {
  conversationItem: FormattedConversationCallOutcome;
  verboseLogsEnabled: boolean;
}

interface Signature {
  Args: ConversationArgs;
  Element: HTMLElement;
}

export default class CallOutcomeConversationItem extends Component<Signature> {
  @service declare intl: IntlService;

  get formattedOutcome() {
    return this.intl.t('ai-agent.voice-playground.conversation.call-outcome.outcome', {
      outcome: this.args.conversationItem.outcome,
    });
  }

  get isErrorOutcome() {
    let outcome = this.args.conversationItem.outcome;
    return outcome === 'error' || outcome === 'client_disconnected';
  }

  get outcomeStyling() {
    return this.isErrorOutcome ? 'text-error' : '';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::VoicePlayground::ConversationItems::CallOutcomeConversationItem': typeof CallOutcomeConversationItem;
  }
}
